import React, { useEffect, useState } from 'react';
import { List, ListItem, ListItemText, Typography, Box, ListItemIcon, Stack, Button, Card, Chip } from '@mui/material';
import { useNavigate } from "react-router-dom";
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import { useApi } from './api'; // Adjust the import path as needed
import {useAuth} from './contexts/authContext'
import SearchBar from './components/SearchBox';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VideocamIcon from '@mui/icons-material/Videocam';

const Persons = ({persons}) => {
  return (
    <Stack direction="row" sx={{mb:1}}>
      {persons.map((person, i) => {
        let lbl = person
        if (person.trim().toLowerCase() === "amma") {
          lbl = "Ummu Salma"
        }
        if (person.trim().toLowerCase() === "aliyamma") {
          lbl = "Aliya"
        }
        if (i !== persons.length -1) {
          lbl += `  ↔️`
        }
        return (<Typography key={`person-${i}`} sx={{mr: 1, fontSize: "12px"}}>{lbl}</Typography>)
      }
      )}
    </Stack>
  )
}
const Tags = ({tags}) => {
  return (
    <Stack direction="row" sx={{mb:1}}>
      {tags.map(tag => (<Chip sx={{height: "15px", lineHeight: "15px", '& .MuiChip-label': { fontSize: 12 }}} label={tag}/>))}
    </Stack>
  )
}

const TextList = () => {
const [items, setItems] = useState([])
const [searchText, setSearchText] = useState("");
const [debouncedText, setDebouncedText] = useState("");
const { get } = useApi()
const navigate = useNavigate();
const {logout} = useAuth()

const getData = async () => {
  const data = await get('/clips')  
  setItems(data);
}

 useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedText(searchText);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchText]);

    useEffect(() => {
    if (!debouncedText.trim()) return;

    const search = async () => {
      const params = new URLSearchParams({
        name: debouncedText,
      });

      const data = await get(`/search?${params}`);

      console.log(data);
      setItems(data)
    };

    search();
  }, [debouncedText]);


useEffect(()=>{
  if(!searchText) {
    getData()
  }
}, [searchText])

useEffect(()=>{
    if (items.length > 0) {
    // On mount, restore scroll position
    const savedPosition = sessionStorage.getItem("scrollPosition");
    console.log(savedPosition)
    if (savedPosition) {
      window.scrollTo(0, parseInt(savedPosition, 10));
    }
  }

}, [items])
  const handleClick = (item, index) => {
    console.log( window.scrollY)
    sessionStorage.setItem("scrollPosition", window.scrollY);
    navigate(`/clip/${item._id}`, {state:{index:index+1}});
    // You can perform any action you want here
  };

  
  return (
    <Box sx={{padding:4}}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h6" gutterBottom>
          റെക്കോഡുകൾ 
        </Typography>
        <Button onClick={()=>{logout()}}variant="contained">Logout</Button>
      </Stack>
      <SearchBar searchText={searchText} setSearchText={setSearchText}/>
      <Stack>
        {searchText && items.length === 0 && (<Typography>No clips found</Typography>)}
        {items.map((item, index) => (
          <Card key={index} sx={{mt: 2, md: 2, padding: 1, position: "relative"}}onClick={() => handleClick(item, index)}>
            {item.type === "audio" ? <VolumeUpIcon sx={{position: "absolute", bottom: 10, right: 10}}/> : <VideocamIcon sx={{position: "absolute", bottom: 10, right: 10}}/>}
            <Stack direction="row" alignItems="center">
              <Typography sx={{mr:2}}>{item.sl_no}</Typography>
              <Stack direction="column">
                <Stack direction="row">
                  <Typography sx={{mr:2, mb:1, fontSize: "20px"}}>{item.title}</Typography>
                  { item.type === "audio" }
                </Stack>
                <Stack direction="row">
                  {item.formatted_duration && (<Typography sx={{fontSize: "12px", mb:1, mr: 2}}>{item.formatted_duration}</Typography>)}
                  {Array.isArray(item?.person) && item.person.length > 0 && (<Persons persons={item.person}/>) }
                </Stack>
                {Array.isArray(item?.tags) && item.tags.length > 0 && (<Tags tags={item.tags}/>) }
                <Typography sx={{fontSize: "12px"}}>{item.date}</Typography>
              </Stack>
            </Stack>
            
          </Card>
        ))}
      </Stack>
    </Box>
  );
};

export default TextList;